import { getActiveNotifications as getNotificationsList } from '@/app/features/admin/notifications/notification-service';
import { createContext, FC, useEffect, useRef, useState } from 'react';
import { NotificationWithAcceptance } from '@ssar-app/domain';

const NotificationsContext = createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  getNotifications: () => {},
  notifications: [] as NotificationWithAcceptance[],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setNotifications: (_notifs: NotificationWithAcceptance[]) => {},
});

const autoRefreshInterval = 30 * 1000;
const NotificationsContextProvider: FC = ({ children }) => {
  const setTimeoutId = useRef(0);
  const [notifications, setNotifications] = useState<
    NotificationWithAcceptance[]
  >([]);

  const getNotifications = async () => {
    await getNotificationsList().then((response) => {
      setNotifications(response.data || []);
      setTimeoutId.current = setTimeout(
        () => getNotifications(),
        autoRefreshInterval,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ) as any;
    });
  };

  useEffect(() => {
    getNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    return () => {
      clearTimeout(setTimeoutId.current);
    };
  }, []);

  return (
    <NotificationsContext.Provider
      value={{
        getNotifications: getNotifications,
        notifications,
        setNotifications,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};

export { NotificationsContext, NotificationsContextProvider };
